module.exports = __webpack_public_path__ + "img/noun_sort.91983614.svg";